export default __webpack_public_path__ + "static/media/3.cd19ea6c.png";